import React from 'react';
import { FiClock, FiInstagram, FiMapPin, FiPhone } from 'react-icons/fi';

import { contacts, images } from '../../constants';

import './Contacts.css';

const Contacts = () => (
  <section className="contacts section" id="contatti" aria-labelledby="contatti-title">
    <div className="container contacts__grid">
      <div className="contacts__text">
        <h2 id="contatti-title" className="display contacts__title">
          <span className="eyebrow">Contatti</span>
          Ti aspettiamo a L’angolo verde.
        </h2>
        <p className="contacts__lead">
          Il tuo bar di fiducia, nel cuore di Ceriano Laghetto. Passa per una colazione, fermati a
          pranzo o contattaci per organizzare il tuo prossimo aperitivo.
        </p>

        <ul className="contacts__list">
          <li>
            <FiMapPin aria-hidden="true" />
            <div>
              <span className="contacts__label">Dove siamo</span>
              <address>{contacts.address}</address>
            </div>
          </li>
          <li>
            <FiClock aria-hidden="true" />
            <div>
              <span className="contacts__label">Orari di apertura</span>
              <dl className="contacts__hours">
                {contacts.hours.map(({ days, time }) => (
                  <div key={days}>
                    <dt>{days}</dt>
                    <dd>{time}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </li>
          <li>
            <FiPhone aria-hidden="true" />
            <div>
              <span className="contacts__label">Telefono</span>
              <a href={contacts.phoneHref}>{contacts.phone}</a>
            </div>
          </li>
          <li>
            <FiInstagram aria-hidden="true" />
            <div>
              <span className="contacts__label">Instagram</span>
              <a href={contacts.instagramUrl} target="_blank" rel="noopener noreferrer">
                {contacts.instagramHandle}
              </a>
            </div>
          </li>
        </ul>

        <div className="contacts__actions">
          <a href={contacts.mapsUrl} className="btn btn--primary" target="_blank" rel="noopener noreferrer">
            <FiMapPin aria-hidden="true" />
            Come arrivare
          </a>
          <a href={contacts.phoneHref} className="btn btn--secondary">
            <FiPhone aria-hidden="true" />
            Chiamaci
          </a>
        </div>
      </div>

      <figure className="contacts__figure">
        <img
          src={images.locale.src}
          width={images.locale.width}
          height={images.locale.height}
          alt="Dietro al bancone del bar, con la macchina del caffè e le bottiglie sullo sfondo"
          loading="lazy"
          decoding="async"
        />
      </figure>
    </div>
  </section>
);

export default Contacts;
